var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightchangeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 33.4015L18.1109 28.642C17.9703 28.6491 17.8292 28.6535 17.6865 28.6535C14.6218 28.6535 12.1286 26.6908 12.1286 24.2774V13.6489H16.4948L8.7943 3.14453L1.09375 13.6489H5.45836V24.2774C5.45836 26.8499 6.73094 29.266 9.04039 31.0855C11.3509 32.9049 14.4205 33.9062 17.6865 33.9062C19.0384 33.9062 20.3563 33.7351 21.6016 33.4015Z",
    fill: "#F39C12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.331 6.34211C20.3919 6.34211 22.8829 8.30156 22.8829 10.7116V21.3637H18.5216L26.2145 31.8555L33.9062 21.3631H29.5449V10.7116C29.5449 8.14242 28.2745 5.72852 25.9678 3.91125C23.66 2.09508 20.5931 1.09375 17.331 1.09375C15.9731 1.09375 14.6491 1.26875 13.3984 1.60344L16.8826 6.35414C17.0313 6.34594 17.1806 6.34211 17.331 6.34211Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightchangeicon);
export default __webpack_public_path__ + "static/media/lightchangeicon.21c45d260d3a881ddc869466bfc804c5.svg";
export { ForwardRef as ReactComponent };